import { aciesDateFormat } from '@shared/helpers';

export interface ITableFilter {
	propertyFilter?: {
		[key: string]: string | number | boolean | Date;
	};
	filterString?: string;
}

function isFilterObject(filter: any): filter is ITableFilter {
	return filter && typeof filter === 'object';
}

export function ModelfilterPredicate(filteredKeys?: string[]): (data: any, filter: string) => boolean {
	return (data: any, filter: string) => {
		if (!isFilterObject(filter)) {
			throw new TypeError('Filter must be a object of type ITableFilter');
		}

		const filterObj = filter as ITableFilter;

		if (!filterObj || (!filterObj.propertyFilter && !filterObj.filterString)) {
			return true; // No filter applied
		}

		let b = !filterObj.filterString;
		if (filterObj.filterString && typeof filterObj.filterString === 'string') {
			for (const key in data) {
				if (filteredKeys && filteredKeys.length > 0 && !filteredKeys.includes(key)) continue;
				if (typeof data[key] === 'string') {
					b = data[key].trim().toLowerCase().includes(filterObj.filterString);
				}
				if (data[key] instanceof Date) {
					b = aciesDateFormat(data[key], true).trim().toLowerCase().includes(filterObj.filterString);
				}
				if (b) break;
			}
		}

		let a = !filterObj.propertyFilter || Object.keys(filterObj.propertyFilter).length === 0;

		for (const key in filterObj.propertyFilter) {
			if (data[key] === undefined || data[key] === null) {
				a = false;
				break;
			}
			if (typeof filterObj.propertyFilter[key] === 'string') {
				a = data[key].toString().trim().toLowerCase() === filterObj.propertyFilter[key].toString().trim().toLowerCase();
			} else if (typeof filterObj.propertyFilter[key] === 'number') {
				a = data[key] === filterObj.propertyFilter[key];
			} else if (typeof filterObj.propertyFilter[key] === 'boolean') {
				a = data[key] === filterObj.propertyFilter[key];
			} else if (filterObj.propertyFilter[key] instanceof Date) {
				a = data[key] === filterObj.propertyFilter[key];
			}
			if (!a) break;
		}

		return a && b;
	};
}
